module.exports = __webpack_public_path__ + "static/media/077-jordan.7d1e2659.svg";